import React from "react"

import type { ProductResponseDto } from "@/api/api-client"

import { filterInventoryProducts } from "./inventory-utils"
import type { InventoryStatusFilter, InventoryViewMode } from "./inventory-types"

interface UseInventoryFiltersOptions {
  products: ProductResponseDto[] | undefined
}

export function useInventoryFilters({ products }: UseInventoryFiltersOptions) {
  const [viewMode, setViewMode] = React.useState<InventoryViewMode>("dense")
  const [statusFilter, setStatusFilter] = React.useState<InventoryStatusFilter>("all")

  const filteredProducts = React.useMemo(
    () => filterInventoryProducts(products, statusFilter),
    [products, statusFilter]
  )

  return {
    filteredProducts,
    statusFilter,
    setStatusFilter,
    viewMode,
    setViewMode,
  }
}
